import get from 'lodash.get';

const getSiteHeader = (rootState) =>
  get(rootState, 'ws.integration.settings.branding.siteHeader', null);

export default getSiteHeader;
